import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppointmentService } from 'shared/services/appointment/appointment.service';

import { ApiError } from '../../interfaces/error.interface';
import { ICalendarEvent } from '../../interfaces/event.interface';
import {
	EProfileBillingStatus,
	IProfessionalProfile,
} from '../../interfaces/professionalprofile.interface';
import { DateTimeService } from '../../services/datetime.service';
import { UserService } from '../../services/user.service';
import { ReceiptModalComponent } from '../receipt-modal/receipt-modal.component';

@Component({
	selector: 'app-receipt-button',
	templateUrl: './receipt-button.component.html',
	styleUrls: ['./receipt-button.component.scss'],
})
export class ReceiptButtonComponent implements OnInit {
	@Input() event: ICalendarEvent;
	@Input() shouldDisableReceiptButton = false;
	@Output() onRequestGenerateReceipt = new EventEmitter<any>();
	isLoading: boolean;
	dialogIsOpen: boolean;
	disabled: boolean;
	profile: IProfessionalProfile;
	constructor(
		private translateService: TranslateService,
		public user: UserService,
		private modalService: BsModalService,
		public appointment: AppointmentService,
		protected dateTime: DateTimeService,
		private actionTrackerService: ActionTrackerService
	) {}

	ngOnInit() {
		this.checkProfessionalPerson();
	}

	generateReceipt() {
		if (this.disabled) {
			return;
		}
		this.isLoading = true;
		const showModal = (response) => {
			this.onRequestGenerateReceipt.emit();
			this.actionTrackerService.eventTracker(
				SCOPE_TYPE.Appointment,
				SUBSCOPE_TYPE.Details,
				ITEM_TYPE.ReceiptBtn,
				INTERACTION_TYPE.Click,
				{}
			);
			let modalMessage = '';
			if (response?.professional) {
				const missingProfessionalData = this.getProfessionalMissingData(
					response.professional
				);
				if (missingProfessionalData.length) {
					modalMessage = this.translateService.instant(
						'SCHEDULE.RECEIPT.PROFESSIONAL_ERROR_MESSAGE',
						{
							missingData: missingProfessionalData.join(', '),
						}
					);
				}
			} else if (response?.profile) {
				const missingData = this.getProfileMissingData(response.profile);
				if (missingData.length) {
					modalMessage = this.translateService.instant(
						'SCHEDULE.RECEIPT.USER_REQUIRED_DATA',
						{
							userName: this.event.userName,
							missingData: missingData.join(', '),
						}
					);
				}
			}
			this.isLoading = false;
			this.modalService.show(ReceiptModalComponent, {
				initialState: {
					status: response?.processed ? 'success' : 'error',
					modalMessage: modalMessage,
				},
			});
		};
		this.appointment.generateReceipt(this.event.id).subscribe(
			(response) => {
				showModal(response);
			},
			(error: ApiError) => {
				showModal((error.error as any)?.data);
			}
		);
	}

	private getProfessionalMissingData(professional) {
		const missingProfessionalData = [];
		[
			['address', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.ADDRESS'],
			['displayName', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.DISPLAY_NAME'],
			['fiscalId', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.FISCALID'],
			['license', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.LICENSE'],
			['region', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.REGION'],
			['signature', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.SIGNATURE'],
			['type', 'SCHEDULE.RECEIPT.PROFESSIONAL_DATA.PROFESSION'],
		].forEach((d: any) => {
			const dataName = d[0];
			const message = this.translateService.instant(d[1]);

			if (!professional[dataName]) {
				missingProfessionalData.push(message);
			}
		});
		return missingProfessionalData;
	}

	private getProfileMissingData(profile) {
		const missingProfileData = [];
		[
			['displayName', 'SCHEDULE.RECEIPT.PROFILE_DATA.DISPLAY_NAME'],
			['fiscalId', 'SCHEDULE.RECEIPT.PROFILE_DATA.FISCALID'],
		].forEach((d: any) => {
			const dataName = d[0];
			const message = this.translateService.instant(d[1]);

			if (!profile[dataName]) {
				missingProfileData.push(message);
			}
		});
		return missingProfileData;
	}

	private checkProfessionalPerson() {
		this.user.checkProfessionalPerson().subscribe((professionalPerson) => {
			if (
				!professionalPerson.status ||
				professionalPerson.status == EProfileBillingStatus.WaitingApproval
			) {
				this.disabled = true;
			}
		});
	}
}
